import { useEffect } from "react";
import { notificationsSocket } from "./notificationsSocket";

export function useNotificationsSocket(url: string | null) {
  useEffect(() => {
    if (!url) return;

    notificationsSocket.connect(url);

    return () => {
      notificationsSocket.disconnect();
    };
  }, [url]);
}
